import { FC } from 'react'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { IIndexEgePageProps } from '../types'
import AboutPlatformBlock from '../../../../../components/Blocks/AboutPlatformBlock/desktop/AboutPlatformBlock'

import ImgRight from '../assets/img__bottom__right__desktop.png'
import ImgLeft from '../assets/img__bottom__left__desktop.png'

const Block = styled.div`
  background-color: ${sv.color.yellow};
  color: white;
  position: relative;
`
const BottomRight = styled.img`
  width: 60px;
  height: 120px;
  position: absolute;
  bottom: -60px;
  right: 0;
  z-index: 1;
`
const BottomLeft = styled.img`
  width: 120px;
  height: 60px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
`

const IndexEgePageAboutPlatform: FC<IIndexEgePageProps['content']['aboutPlatform']> = (
  props
) => {
  const {
    aboutWebinarsAndTests,
    aboutVideoLessons,
    aboutDashboard,
    aboutHomeworks,
    aboutOrganization,
  } = props
  return (
    <Block id='studying'>
      <AboutPlatformBlock
        aboutWebinarsAndTests={aboutWebinarsAndTests}
        aboutVideoLessons={aboutVideoLessons}
        aboutDashboard={aboutDashboard}
        aboutHomeworks={aboutHomeworks}
        aboutOrganization={aboutOrganization}
        showMore
        href='https://school.ucheba.ru/demo'
      />

      <BottomLeft src={ImgLeft} />
      <BottomRight src={ImgRight} />
    </Block>
  )
}

export default IndexEgePageAboutPlatform
